"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsPriorityReadinessChart = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
require("./PriorityReadinessChart.scss");
var TOOLTIP_MARGIN_PX = 8;
var TOOLTIP_VERTICAL_OFFSET_PX = 6;
var TOOLTIP_HORIZONTAL_OFFSET_PX = 6;
var TOOLTIP_ESTIMATED_WIDTH_PX = 300;
var TOOLTIP_BASE_HEIGHT_PX = 36;
var TOOLTIP_ROW_HEIGHT_PX = 36;
var PRIORITY_BAND_HEIGHT_PX = 42;
var joinClassNames = function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    return names.filter(Boolean).join(' ');
};
var clampPercent = function (value) {
    if (!Number.isFinite(value)) {
        return 0;
    }
    if (value < 0) {
        return 0;
    }
    if (value > 100) {
        return 100;
    }
    return value;
};
var formatPercent = function (value) {
    var rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? "" + rounded : "" + rounded.toFixed(1);
};
var getCoordKey = function (readiness, impact) {
    return readiness.toFixed(2) + "|" + impact.toFixed(2);
};
var getPointTone = function (readiness, impact) {
    var isLowReadiness = readiness < 50;
    var isLowImpact = impact < 50;
    if (isLowReadiness && isLowImpact) {
        return 'orange';
    }
    if (!isLowReadiness && !isLowImpact) {
        return 'green';
    }
    return 'blue';
};
var isInsideTooltipForCoord = function (target, coordKey) {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    var tooltip = target.closest('[data-stacked-tooltip-coord]');
    if (!(tooltip instanceof HTMLElement)) {
        return false;
    }
    return tooltip.dataset.stackedTooltipCoord === coordKey;
};
var isInsidePointForCoord = function (target, coordKey) {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    var point = target.closest('[data-chart-point-coord]');
    if (!(point instanceof HTMLElement)) {
        return false;
    }
    return point.dataset.chartPointCoord === coordKey;
};
var WsPriorityReadinessChart = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var useCases = _a.useCases, className = _a.className, highlightedUseCaseId = _a.highlightedUseCaseId, impactAxisLabel = _a.impactAxisLabel;
    var _l = react_1.useState(null), activePoint = _l[0], setActivePoint = _l[1];
    var gridRef = react_1.useRef(null);
    var hasPinnedUseCase = typeof highlightedUseCaseId === 'string' && highlightedUseCaseId.trim().length > 0;
    var resolvedImpactAxisLabel = impactAxisLabel && impactAxisLabel.trim() ? impactAxisLabel.trim() : 'Business Value';
    var points = useCases.map(function (useCase, index) {
        var key = useCase.id || useCase.title + "-" + index;
        var useCaseId = typeof useCase.id === 'string' && useCase.id.trim() ? useCase.id : undefined;
        var readiness = clampPercent(useCase.readinessScore);
        var impact = clampPercent(useCase.impactScore);
        var isHighlighted = hasPinnedUseCase && String(useCase.id || '') === highlightedUseCaseId;
        return {
            key: key,
            useCaseId: useCaseId,
            title: useCase.title,
            readiness: readiness,
            impact: impact,
            coordKey: getCoordKey(readiness, impact),
            isHighlighted: isHighlighted,
        };
    });
    var groupedPointsByCoord = points.reduce(function (result, point) {
        var existingGroup = result[point.coordKey];
        if (!existingGroup) {
            result[point.coordKey] = {
                coordKey: point.coordKey,
                readiness: point.readiness,
                impact: point.impact,
                tone: point.isHighlighted ? 'yellow' : getPointTone(point.readiness, point.impact),
                items: [
                    {
                        key: point.key,
                        useCaseId: point.useCaseId,
                        title: point.title,
                        readiness: point.readiness,
                        impact: point.impact,
                        isHighlighted: point.isHighlighted,
                    },
                ],
                isHighlighted: point.isHighlighted,
            };
            return result;
        }
        existingGroup.isHighlighted = existingGroup.isHighlighted || point.isHighlighted;
        if (existingGroup.isHighlighted) {
            existingGroup.tone = 'yellow';
        }
        existingGroup.items.push({
            key: point.key,
            useCaseId: point.useCaseId,
            title: point.title,
            readiness: point.readiness,
            impact: point.impact,
            isHighlighted: point.isHighlighted,
        });
        return result;
    }, {});
    var groupedPoints = Object.values(groupedPointsByCoord);
    var pinnedPoint = react_1.useMemo(function () {
        if (!hasPinnedUseCase) {
            return null;
        }
        var highlightedGroup = groupedPoints.find(function (point) { return point.isHighlighted; });
        if (!highlightedGroup) {
            return null;
        }
        var highlightedItem = highlightedGroup.items.find(function (item) { return item.isHighlighted; }) || highlightedGroup.items[0];
        return {
            key: (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.key) || highlightedGroup.coordKey,
            title: (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.title) || 'Use case',
            readiness: highlightedGroup.readiness,
            impact: highlightedGroup.impact,
            coordKey: highlightedGroup.coordKey,
        };
    }, [groupedPoints, hasPinnedUseCase]);
    var displayedActivePoint = pinnedPoint || activePoint;
    var tooltipPoint = hasPinnedUseCase ? null : activePoint;
    var stackedItemsAtActivePoint = tooltipPoint
        ? ((_c = (_b = groupedPointsByCoord[tooltipPoint.coordKey]) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])
        : [];
    var readinessLinePosition = (_d = displayedActivePoint === null || displayedActivePoint === void 0 ? void 0 : displayedActivePoint.readiness) !== null && _d !== void 0 ? _d : 0;
    var impactLinePosition = displayedActivePoint ? 100 - displayedActivePoint.impact : 0;
    var gridWidth = (_f = (_e = gridRef.current) === null || _e === void 0 ? void 0 : _e.clientWidth) !== null && _f !== void 0 ? _f : 900;
    var gridHeight = (_h = (_g = gridRef.current) === null || _g === void 0 ? void 0 : _g.clientHeight) !== null && _h !== void 0 ? _h : 420;
    var gridRect = (_j = gridRef.current) === null || _j === void 0 ? void 0 : _j.getBoundingClientRect();
    var viewportHeight = typeof window === 'undefined' ? 900 : window.innerHeight;
    var visibleGridTop = gridRect ? Math.max(gridRect.top, 0) : 0;
    var visibleGridBottom = gridRect ? Math.min(gridRect.bottom, viewportHeight) : viewportHeight;
    var visibleGridHeight = Math.max(180, visibleGridBottom - visibleGridTop);
    var maxTooltipHeight = Math.max(140, visibleGridHeight - TOOLTIP_MARGIN_PX * 2);
    var estimatedTooltipHeight = TOOLTIP_BASE_HEIGHT_PX + stackedItemsAtActivePoint.length * TOOLTIP_ROW_HEIGHT_PX;
    var tooltipHeight = Math.min(estimatedTooltipHeight, maxTooltipHeight);
    var plotAreaInset = PRIORITY_BAND_HEIGHT_PX;
    var plotAreaHeight = Math.max(100, gridHeight - plotAreaInset * 2);
    var activeImpactPositionPx = plotAreaInset + (impactLinePosition / 100) * plotAreaHeight;
    var anchorX = (((_k = tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.readiness) !== null && _k !== void 0 ? _k : 0) / 100) * gridWidth;
    var anchorY = plotAreaInset + ((tooltipPoint ? 100 - tooltipPoint.impact : 0) / 100) * plotAreaHeight;
    var tooltipLeftPx = anchorX + TOOLTIP_HORIZONTAL_OFFSET_PX;
    if (tooltipLeftPx + TOOLTIP_ESTIMATED_WIDTH_PX > gridWidth - TOOLTIP_MARGIN_PX) {
        tooltipLeftPx = anchorX - TOOLTIP_ESTIMATED_WIDTH_PX - TOOLTIP_HORIZONTAL_OFFSET_PX;
    }
    tooltipLeftPx = Math.max(TOOLTIP_MARGIN_PX, Math.min(tooltipLeftPx, gridWidth - TOOLTIP_ESTIMATED_WIDTH_PX - TOOLTIP_MARGIN_PX));
    var tooltipTopPx = anchorY - tooltipHeight - TOOLTIP_VERTICAL_OFFSET_PX;
    if (tooltipTopPx < TOOLTIP_MARGIN_PX) {
        tooltipTopPx = anchorY + TOOLTIP_VERTICAL_OFFSET_PX;
    }
    tooltipTopPx = Math.max(TOOLTIP_MARGIN_PX, Math.min(tooltipTopPx, gridHeight - tooltipHeight - TOOLTIP_MARGIN_PX));
    return (react_1.default.createElement("section", { className: joinClassNames('ws-ai-hub-priority-readiness-chart', className) },
        react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-layout" },
            react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-axis-y", "aria-hidden": "true" },
                react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-y-arrow ws-ai-hub-priority-readiness-chart-axis-y-arrow-up" }),
                react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-y-label" }, "IMPACT"),
                react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-y-arrow ws-ai-hub-priority-readiness-chart-axis-y-arrow-down" })),
            react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-content" },
                react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-grid", ref: gridRef, role: "img", "aria-label": "Use case chart with readiness on horizontal axis and " + resolvedImpactAxisLabel + " on vertical axis" },
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-quadrant ws-ai-hub-priority-readiness-chart-quadrant-top-left" }),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-quadrant ws-ai-hub-priority-readiness-chart-quadrant-top-right" }),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-quadrant ws-ai-hub-priority-readiness-chart-quadrant-bottom-left" }),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-quadrant ws-ai-hub-priority-readiness-chart-quadrant-bottom-right" }),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-priority-band ws-ai-hub-priority-readiness-chart-priority-band-top-left" },
                        react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-priority-label" }, "MEDIUM PRIORITY (high impact & low readiness)")),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-priority-band ws-ai-hub-priority-readiness-chart-priority-band-top-right" },
                        react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-priority-label" }, "HIGH PRIORITY (high impact & high readiness)")),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-priority-band ws-ai-hub-priority-readiness-chart-priority-band-bottom-left" },
                        react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-priority-label" }, "LOW PRIORITY (low impact & low readiness)")),
                    react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-priority-band ws-ai-hub-priority-readiness-chart-priority-band-bottom-right" },
                        react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-priority-label" }, "MEDIUM PRIORITY (low impact & high readiness)")),
                    displayedActivePoint && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-threshold ws-ai-hub-priority-readiness-chart-threshold-readiness", style: {
                                left: readinessLinePosition + "%",
                                top: plotAreaInset + "px",
                                bottom: plotAreaInset + "px",
                            }, "aria-hidden": "true" },
                            react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-threshold-label ws-ai-hub-priority-readiness-chart-threshold-label-readiness" },
                                formatPercent(displayedActivePoint.readiness),
                                "% readiness")),
                        react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-threshold ws-ai-hub-priority-readiness-chart-threshold-impact", style: { top: activeImpactPositionPx + "px" }, "aria-hidden": "true" },
                            react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-threshold-label ws-ai-hub-priority-readiness-chart-threshold-label-impact" },
                                formatPercent(displayedActivePoint.impact),
                                "% business value")))),
                    tooltipPoint && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-stacked-tooltip", "data-stacked-tooltip-coord": tooltipPoint.coordKey, style: {
                                left: tooltipLeftPx + "px",
                                top: tooltipTopPx + "px",
                                maxHeight: maxTooltipHeight + "px",
                            }, "aria-hidden": "true", onMouseLeave: function (event) {
                                if (isInsidePointForCoord(event.relatedTarget, tooltipPoint.coordKey)) {
                                    return;
                                }
                                setActivePoint(function (current) {
                                    return (current === null || current === void 0 ? void 0 : current.coordKey) === tooltipPoint.coordKey ? null : current;
                                });
                            } },
                            react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-stacked-tooltip-title" }, stackedItemsAtActivePoint.length > 1
                                ? stackedItemsAtActivePoint.length + " use cases in this point"
                                : 'Use case in this point'),
                            react_1.default.createElement("ul", { className: "ws-ai-hub-priority-readiness-chart-stacked-tooltip-list" }, stackedItemsAtActivePoint.map(function (item) { return (react_1.default.createElement("li", { key: item.key },
                                item.useCaseId ? (react_1.default.createElement(react_router_dom_1.Link, { to: ai_hub_route_utils_1.buildAiHubUseCaseDetailsPath(item.useCaseId), className: "ws-ai-hub-priority-readiness-chart-tooltip-link" }, item.title)) : (react_1.default.createElement("strong", null, item.title)),
                                react_1.default.createElement("span", null,
                                    "R: ",
                                    formatPercent(item.readiness),
                                    "% | I: ",
                                    formatPercent(item.impact),
                                    "%"))); }))))),
                    groupedPoints.map(function (point) {
                        var _a;
                        var pointTop = plotAreaInset + ((100 - point.impact) / 100) * plotAreaHeight;
                        var isActivePoint = (displayedActivePoint === null || displayedActivePoint === void 0 ? void 0 : displayedActivePoint.coordKey) === point.coordKey;
                        var pointTone = point.tone;
                        return (react_1.default.createElement("button", { key: point.coordKey, type: "button", "data-chart-point-coord": point.coordKey, className: joinClassNames('ws-ai-hub-priority-readiness-chart-point', "ws-ai-hub-priority-readiness-chart-point-" + pointTone, point.isHighlighted && 'ws-ai-hub-priority-readiness-chart-point-highlighted', isActivePoint && 'ws-ai-hub-priority-readiness-chart-point-active'), style: { left: point.readiness + "%", top: pointTop + "px" }, "aria-label": point.items.length > 1
                                ? point.items.length + " use cases. Readiness " + formatPercent(point.readiness) + " percent. Impact " + formatPercent(point.impact) + " percent."
                                : (((_a = point.items[0]) === null || _a === void 0 ? void 0 : _a.title) || 'Use case') + ". Readiness " + formatPercent(point.readiness) + " percent. Impact " + formatPercent(point.impact) + " percent.", onMouseEnter: function () {
                                var _a;
                                if (hasPinnedUseCase) {
                                    return;
                                }
                                setActivePoint({
                                    key: point.coordKey,
                                    title: ((_a = point.items[0]) === null || _a === void 0 ? void 0 : _a.title) || 'Use case',
                                    readiness: point.readiness,
                                    impact: point.impact,
                                    coordKey: point.coordKey,
                                });
                            }, onFocus: function () {
                                var _a;
                                if (hasPinnedUseCase) {
                                    return;
                                }
                                setActivePoint({
                                    key: point.coordKey,
                                    title: ((_a = point.items[0]) === null || _a === void 0 ? void 0 : _a.title) || 'Use case',
                                    readiness: point.readiness,
                                    impact: point.impact,
                                    coordKey: point.coordKey,
                                });
                            }, onMouseLeave: function (event) {
                                if (hasPinnedUseCase) {
                                    return;
                                }
                                if (isInsideTooltipForCoord(event.relatedTarget, point.coordKey)) {
                                    return;
                                }
                                setActivePoint(function (current) {
                                    return (current === null || current === void 0 ? void 0 : current.coordKey) === point.coordKey ? null : current;
                                });
                            }, onBlur: function () {
                                if (hasPinnedUseCase) {
                                    return;
                                }
                                setActivePoint(function (current) {
                                    return (current === null || current === void 0 ? void 0 : current.coordKey) === point.coordKey ? null : current;
                                });
                            } }));
                    })),
                react_1.default.createElement("div", { className: "ws-ai-hub-priority-readiness-chart-axis-x", "aria-hidden": "true" },
                    react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-x-arrow ws-ai-hub-priority-readiness-chart-axis-x-arrow-left" }),
                    react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-x-label" }, "Readiness"),
                    react_1.default.createElement("span", { className: "ws-ai-hub-priority-readiness-chart-axis-x-arrow ws-ai-hub-priority-readiness-chart-axis-x-arrow-right" }))))));
};
exports.WsPriorityReadinessChart = WsPriorityReadinessChart;
